import '@mockup/func/globals/App.util';

export const tableExpander = {
    init: function () {
        $('table.table').each(function () {
            var _ = $(this);
            if (!_.find('.expander').length) {
                return;
            }

            _.find('.expander').on('click', function () {
                $(this).toggleClass('open');
                var id = '.' + $(this).data('expanderElementsId');
                _.find(id).toggleClass('is-open');
            });

            _.find('tbody tr:visible').each((index, elm) => {
                $(elm).addClass((index + 1) % 2 === 0 ? 'is-even' : 'is-odd');
            });
        });
    }
};

App.Util.tableExpander = tableExpander;

export default tableExpander;

